import Section from "../Section";
import Swiper from 'swiper';

export default class InfoColumns extends Section {
  constructor(theme, element, pageLoad) {
    super(theme, element, pageLoad);

    this.slidesPerView = parseInt(this.element.dataset.slidesPerRow);
    this.swiperContainer = this.element.querySelector('.swiper-container');
    this.numberOfSlides = parseInt((/** @type {HTMLElement} */ (this.swiperContainer)).dataset.numberOfSlides, 10);
    const nextEl = this.element.querySelector('.swiper-button--next');
    const prevEl = this.element.querySelector('.swiper-button--prev');
    this.swiper = new Swiper(this.swiperContainer, {
      slidesPerView: 1,
      allowTouchMove: true,
      navigation: {
        nextEl,
        prevEl,
      },
      breakpoints: {
        // when window width is >= 768px
        769: {
          slidesPerView: this.slidesPerView,
        },
      },
      watchOverflow: true,
      autoHeight: true,
      loop: true,
      pagination: {
        el: this.swiperContainer.querySelectorAll('.swiper-pagination'),
        clickable: true,
      },
    });
  }

  isSlideInViewport = (el) => {
    const slideIndex = parseInt(el.dataset.swiperSlideIndex, 10);   // slideIndex contains the index of the slide (relative value which goes from 0 to numberOfSlides-1)
    const activeSlideIndex = parseInt((/** @type {HTMLElement} */ (this.element.querySelector('.swiper-slide-active'))).dataset.swiperSlideIndex, 10);
    const lastVisibleIndex = activeSlideIndex + this.slidesPerView - 1;   // contains absolute value (can exceed the total number of slides)

    // Check if the slide is in the visible area
    if (slideIndex >= activeSlideIndex && slideIndex <= lastVisibleIndex) {
      return true;
    }

    const absoluteSlideIndex = slideIndex + this.numberOfSlides;
    if(absoluteSlideIndex >= activeSlideIndex && absoluteSlideIndex <= lastVisibleIndex) {
      return true;
    }

    return false;
  }

  onBlockSelect = ({ element }) => {
    if (this.isSlideInViewport(element)) return;
    const index = parseInt(element.dataset.swiperSlideIndex, 10) + 1;
    const transitionDuration = 300; // Transition duration (ms) – 300 is the default value
    this.swiper.slideTo(index, transitionDuration, false)
  }
}
